import { Badge, Button, Divider, LoadingOverlay, Text, Title } from '@mantine/core';
import { useClipboard, useFocusTrap } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useApp } from '../../contexts/app.context';
import { useAuth } from '../../contexts/auth.context';
import { GET_THEME_INSIGHTS, SAVE_THEME_ADDITIONAL_DATA } from '../../services/themes';
import InputField, { InputFieldTypes } from '../input_field';

export default function ThemeInsights({ id, type = "commissions" } : { id: string; type?: "commissions" | "similars" }){
    const [data, setData] = React.useState<any>(null);
    const [update, setUpdate] = React.useState<any>({});
    const [loadingDetails, setLoadingDetails] = React.useState(false);
    const [loadingSave, setLoadingSave] = React.useState(false);

    const { openTheme } = useApp();
    
    const loadDetails = () => {
        setLoadingDetails(true)
        
        GET_THEME_INSIGHTS(id, type)
        .then((insights) => {
            setLoadingDetails(false)
            setData(insights)
        })
        .catch(err => {
            setLoadingDetails(false)
            showNotification({color: 'red', message: err.message})
        })
    }

    const save = ({ type, data }) => {
        setLoadingSave(true)

        SAVE_THEME_ADDITIONAL_DATA(id, {type, data})
        .then(() => {
            setLoadingSave(false)
            loadDetails()
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({color: 'red', message: err.message})
        })
    }

    React.useEffect(loadDetails, [])

    return <div style={{padding: '0'}}>
        <LoadingOverlay visible={loadingDetails || loadingSave} />
        
        {type === "commissions" && <div>
            {(data?.commissions || []).length > 0 && <div>
                <Title order={3}>Comissões atuais:</Title>

                {data?.commissions.map(c => (
                    <div>
                        <Divider mt="xs" mb="xs" />
                        <Text weight="bold">{c.title}</Text>
                        <div style={{textAlign: 'right'}}>
                            <Button onClick={() => window.open(`/entidade/${c.id}`, "_blank")}>Detalhes</Button>
                        </div>
                    </div>
                ))}
            </div>}
            {
                data?.ready
                ? <div>
                    {(data?.matchCommissions || []).length === 0
                        ? <Title order={3}>Nenhuma comissão recomendada com base nas palavras-chaves</Title>
                        : <Title order={3}>Comissões recomendadas:</Title>}
                    {(data?.matchCommissions || []).map(c => (
                        <div>
                            <Divider mt="xs" mb="xs" />
                            <Text weight="bold">{c.title}</Text>
                            <Text>Palavras-chaves: {c.matchKeywords.map(k => <Badge mr="sm" mb="sm" color="teal">{k}</Badge>)}</Text>
                            <div style={{textAlign: 'right'}}>
                                <Button onClick={() => window.open(`/entidade/${c.id}`, "_blank")}>Detalhes</Button>
                            </div>
                        </div>
                    ))}
                </div>
                : <div>
                    {(data?.requireds || []).map(r => <div>
                        <InputField
                            title={r.title}
                            type={InputFieldTypes.TEXTAREA}
                            name="upd"
                            value={update[r.type]}
                            onChange={({upd}) => setUpdate(u => ({...u, [r.type]: upd}))} />

                        <Button mt="md" onClick={() => save({type: r.type, data: update[r.type]})}>Salvar</Button>
                    </div>)}
                </div>
            }
        </div>}
        {type === "similars" && <div>
            {
                data?.ready
                ? <div>
                    {(data?.similarsThemes || []).length === 0
                        ? <Title order={3}>Nenhuma pauta similar com base nas palavras-chaves</Title>
                        : <Title order={3}>Pautas similares:</Title>}
                    {(data?.similarsThemes || []).map(c => (
                        <div>
                            <Divider mt="xs" mb="xs" />
                            <Text weight="bold">{c.title}</Text>
                            <Text>Palavras-chaves: {c.matchKeywords.map(k => <Badge mr="sm" mb="sm" color="teal">{k}</Badge>)}</Text>
                            <div style={{textAlign: 'right'}}>
                                <Button onClick={() => openTheme(c)}>Abrir</Button>
                            </div>
                        </div>
                    ))}
                </div>
                : <div>
                    {(data?.requireds || []).map(r => <div>
                        <InputField
                            title={r.title}
                            type={InputFieldTypes.TEXTAREA}
                            name="upd"
                            value={update[r.type]}
                            onChange={({upd}) => setUpdate(u => ({...u, [r.type]: upd}))} />

                        <Button mt="md" onClick={() => save({type: r.type, data: update[r.type]})}>Salvar</Button>
                    </div>)}
                </div>
            }
        </div>}
    </div>
}